var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.861,
    x2: 309.282,
    xlinkHref: "#lg1",
    y1: 344.457,
    y2: 562.2
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#d22725",
    stopOpacity: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.792,
    x2: 332.705,
    xlinkHref: "#lg2",
    y1: 462.69,
    y2: 481.543
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(-1 0 0 1 647.668 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 463.46,
    x2: 470.373,
    xlinkHref: "#lg2",
    y1: 462.69,
    y2: 481.544
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.471,
    x2: 261.182,
    xlinkHref: "#lg2",
    y1: 496.742,
    y2: 325.97
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.988,
    x2: 368.923,
    xlinkHref: "#lg1",
    y1: 219.542,
    y2: 219.542
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.539,
    x2: 297.998,
    xlinkHref: "#lg3",
    y1: 309.363,
    y2: 309.363
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.539,
    x2: 297.998,
    xlinkHref: "#lg3",
    y1: 159.03,
    y2: 159.03
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m235.898 334.233-211.923 73.159c-12.469 4.305-12.469 21.94 0 26.244l211.923 73.159c12.376 4.272 25.827 4.272 38.203 0l211.923-73.159c12.469-4.305 12.469-21.94 0-26.244l-211.923-73.159c-12.375-4.272-25.827-4.272-38.203 0z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.025 407.392-72.592-25.06-269.036 92.875 91.502 31.588c12.376 4.272 25.827 4.272 38.203 0l211.923-73.159c12.469-4.304 12.469-21.939 0-26.244z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.975 407.392 72.592-25.06 269.036 92.875-91.502 31.588c-12.376 4.272-25.827 4.272-38.203 0l-211.923-73.158c-12.469-4.305-12.469-21.94 0-26.245z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m486.03 433.635-211.928 73.159c-12.377 4.272-25.825 4.272-38.201 0l-23.951-8.266-82.42-82.42c-6.531-4.925-9.497-16.06-6.445-25.846l5.964-19.143 106.853-36.884c12.377-4.272 25.825-4.272 38.201 0l211.928 73.158c12.461 4.304 12.461 21.938-.001 26.242z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 439.083c66.471 0 104.601-12.654 123.225-21.576 8.074-3.868 12.072-16.392 8.692-27.244l-13.028-41.817-21.813-39.085-6.304-51.162-17.139-55.01-24.38-47.04-4.507-45.681-30.331-97.354c-5.448-17.488-23.379-17.488-28.827 0l-30.331 97.354-5.218 48.56-23.669 44.161-17.139 55.01-5.587 46.415-22.529 43.831-13.028 41.817c-3.381 10.851.618 23.376 8.692 27.244 18.62 8.924 56.75 21.577 123.221 21.577z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.889 348.447c-.404.128-.816.236-1.229.321-34.655 7.473-74.824 11.756-117.66 11.756s-83.005-4.283-117.66-11.756c-.412-.086-.825-.193-1.229-.321l28.116-90.247c27.946 4.379 58.608 6.799 90.773 6.799s62.827-2.42 90.773-6.799z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.636 203.19c-23.176 2.859-47.921 4.4-73.636 4.4s-50.459-1.542-73.636-4.4l28.892-92.72c14.486 1.049 29.449 1.595 44.744 1.595s30.258-.546 44.744-1.595z",
    fill: "url(#SVGID_7_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCone);
export default __webpack_public_path__ + "static/media/icon-cone.2a240ca2c1c9b2f70351df8334d2f4b9.svg";
export { ForwardRef as ReactComponent };